import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TriangleAlert } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

// Prominent nudge for studios: delivered jobs with no service/products logged block the warranty.
export const MissingServiceBanner = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/alerts")
      .then(({ data }) => setItems(data.service_missing || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <div
      className="mb-6 rounded-lg border-2 border-amber-400 bg-amber-50 p-4"
      data-testid="dashboard-missing-service-banner"
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <TriangleAlert className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
          <div>
            <p className="font-semibold text-amber-900">
              Action needed: {items.length} delivered job{items.length > 1 ? "s" : ""} missing
              service &amp; products
            </p>
            <p className="mt-1 text-xs text-amber-800">
              A warranty cannot be issued for these customers until you add the service and products
              used on each job. Open the job, add them, and the central team will register the
              warranty automatically.
            </p>
          </div>
        </div>
        <Button
          asChild
          size="sm"
          className="min-h-[40px] bg-amber-600 hover:bg-amber-700"
          data-testid="dashboard-missing-service-cta"
        >
          <Link to="/alerts">Review &amp; fix</Link>
        </Button>
      </div>
    </div>
  );
};
